import { render, staticRenderFns } from "./TypeStagesList.vue?vue&type=template&id=64db1892&"
import script from "./TypeStagesList.vue?vue&type=script&lang=js&"
export * from "./TypeStagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports